import { TaskKindEnum } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { AssignationsType, FieldNames } from 'routes/Task/enums';

// Keep a key for EVERY field name the task form renders (custom renders
// included): FormContainer compares values to a baseline, so a field that
// registers later with a key missing here makes the form dirty again after a
// successful submit and the leave-page blocker stops the redirect (DAT-1637).
const getEmptyDefaultValues = (values?: Values): Values => ({
  // step 1
  [FieldNames.taskName]: '',
  [FieldNames.taskDescription]: '',
  [FieldNames.priority]: undefined,
  [FieldNames.site]: undefined,
  [FieldNames.template]: undefined,
  [FieldNames.templateVersion]: undefined,
  [FieldNames.documentationLinks]: [],
  [FieldNames.assignationsType]: { value: AssignationsType.Area },
  [FieldNames.siteArea]: undefined,
  [FieldNames.asset]: undefined,
  [FieldNames.approver]: undefined,
  [FieldNames.departmentLinks]: [],
  // step 2
  [FieldNames.taskKind]: { value: TaskKindEnum.Standard },
  [FieldNames.deadlineAt]: '',
  [FieldNames.earlyCompletionType]: undefined,
  [FieldNames.recurringRuleEnabled]: false,
  [FieldNames.earlyCompletionEnabled]: false,
  [FieldNames.earlyCompletionAmount]: 1,
  [FieldNames.endRepeatEnabled]: false,
  [FieldNames.repeatMonthlyRepeatOnOptions]: [],
  [FieldNames.repeatYearlyRepeatOnOptions]: [],
  [FieldNames.recurringRuleRuleType]: undefined,
  [FieldNames.recurringRuleInterval]: undefined,
  [FieldNames.recurringRuleDayOfWeek]: undefined,
  [FieldNames.recurringRuleCountdownType]: undefined,
  [FieldNames.recurringRuleExcludedDayOfWeek]: undefined,
  [FieldNames.repeatMonthlyType]: undefined,
  [FieldNames.repeatMonthlyEachDayOfMonth]: undefined,
  [FieldNames.repeatYearlyType]: undefined,
  [FieldNames.repeatYearlyEachMonthOfYear]: undefined,
  [FieldNames.repeatYearlyEachDayOfMonth]: undefined,
  [FieldNames.repeatYearlyRepeatOnMonthOfYear]: undefined,
  [FieldNames.endRepeatType]: undefined,
  [FieldNames.endRepeatDate]: undefined,
  [FieldNames.endRepeatAfterOccurrences]: undefined,
  // Custom
  ...values,
  // Custom renders
  [FieldNames.taskDetails]: null,
  [FieldNames.templateTitle]: null,
  [FieldNames.templateVersionViewBtn]: null,
  [FieldNames.assignationsTitle]: null,
  [FieldNames.assignationsTypeDesc]: null,
  [FieldNames.tasksDetails]: null,
  [FieldNames.scheduleTask]: null,
  [FieldNames.scheduleMessage]: null,
  [FieldNames.tasksDuplicationWarning]: null,
  [FieldNames.departmentsAndVisibilityTitle]: null,
  [FieldNames.recurringRuleDivider]: null,
  [FieldNames.recurringRuleSpace]: null,
  [FieldNames.recurringRuleCountdownDivider]: null,
  [FieldNames.recurringRuleCountdownTitle]: null,
  [FieldNames.recurringRuleExcludedDayOfWeekTitle]: null,
});

export default getEmptyDefaultValues;
